export default "__VITE_ASSET__DAOACt9G__"